// @flow

import objectHash from 'object-hash';
import {request} from './request';
import bulkApiService from './bulk-api-service';
import {isOk} from './utils/is-ok';
import {OBSOLETE_REQUEST_ERROR} from './constants';

import type {CallApi} from './typedef';


const cacheCalls = {};

export const callApi: CallApi = (callInfo, apiRoot, store) => {
    if (callInfo.cache) {
        const currentHash = objectHash(callInfo);
        if (!cacheCalls[currentHash]) {
            return cacheCalls[currentHash] = request(callInfo, apiRoot)
                .then(({responseData, response}) => {
                    delete cacheCalls[currentHash];
                    return Promise.resolve({responseData, response, store});
                })
                .catch(error => {
                    delete cacheCalls[currentHash];
                    return Promise.resolve({error});
                });
        } else {
            return cacheCalls[currentHash];
        }
    } else if (callInfo.bulk) {
        return bulkApiService.add(callInfo, apiRoot).then(responseItem => {
            const responseData = responseItem.body;
            const response = {
                status: responseItem.status,
                ok: isOk(responseItem.status)
            };
            return Promise.resolve({responseData, response, store});
        });
    } else {
        return request(callInfo, apiRoot)
            .then(({responseData, response}) => {
                return Promise.resolve({responseData, response, store});
            })
            .catch(error => {
                if (error.name === 'AbortError') {
                    return Promise.resolve({error: OBSOLETE_REQUEST_ERROR});
                }

                return Promise.resolve({error});
            });
    }
};

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("./typedef");
